import { Dispatch, FC, SetStateAction } from 'react';
import { Flex } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { issuesPrior } from 'src/constants/issuesPrior';
import { IReportDashboard } from 'src/store';

import styles from './styles.module.scss';
import { IssuesByPriorityItem } from './components';

interface IssuesByPriorityProps {
  data: IReportDashboard | null;
  loading: boolean;
  setSearchQuery: Dispatch<SetStateAction<{ [key: string]: string | null }>>;
  searchQuery: { [key: string]: string | null };
  css? :  {[key: string]: string | null};
}

const IssuesByPriority: FC<IssuesByPriorityProps> = ({ data, loading, setSearchQuery, searchQuery , css }): JSX.Element => {
  const [t] = useTranslation('automatedReports');

  return (
    <div className={styles['issues-by-priority']} style={css}>
      <h2>{t('titlePrior')}</h2>
      <Flex className={styles['prior']}>
        {issuesPrior.map((item) => (
          <IssuesByPriorityItem 
            loading={loading}
            key={item.field}
            icon={item.icon}
            field={item.field}
            filter={item.filter}
            title={item.title}
            issueValue={data?.countBySeverity?.[item.field] ?? '--'}
            setSearchQuery={setSearchQuery}
            searchQuery={searchQuery}
          />
        ))}
      </Flex>
    </div>
  );
};

export default IssuesByPriority;
